// Globals
import React, { useCallback, useState } from 'react';
import { Upload } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { StyledImage } from './UploadDraggerStyles';
import { UploadIcon } from '@/icons';
import { Button } from '@/ui';

type TUploadDragger = {
  value?: string;
  onChange?: (file: File | Blob, imageUrl: string) => void;
  acceptance?: string;
};

const UploadDragger = ({ acceptance, value, onChange }: TUploadDragger) => {
  const { t } = useTranslation();

  const [imageSrc, setImageSrc] = useState<string | undefined>(value);

  const handleChange = useCallback(
    async (image: Blob) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = async () => {
        if (typeof reader.result === 'string') {
          const url = reader.result;
          setImageSrc(url);
          onChange?.(image, url);
        }
      };
      return false;
    },
    [onChange],
  );

  return (
    <Upload.Dragger maxCount={1} accept={acceptance} showUploadList={false} beforeUpload={handleChange}>
      {imageSrc && <StyledImage src={imageSrc} />}
      <UploadIcon style={{ height: '1rem', width: '100%' }} />
      <p>{t('image_upload_drag_text')}</p>
      <Button type={'primary'}>{t('image_upload_choose_text')}</Button>
    </Upload.Dragger>
  );
};

export default UploadDragger;
